import * as React from "react";

type ArrowUpRightProps = React.SVGProps<SVGSVGElement> & {
  size?: "sm" | "lg";
};

const ArrowUpRight = React.forwardRef<SVGSVGElement, ArrowUpRightProps>(
  ({ size = "sm", ...props }, ref) => {
    const dimensions = size === "lg" ? 20 : 16;

    return (
      <svg
        ref={ref}
        width={dimensions}
        height={dimensions}
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}
      >
        <path
          d="M6.00005 19L19 5.99996M19 5.99996V18.48M19 5.99996H6.52005"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);

ArrowUpRight.displayName = "ArrowUpRight";

export { ArrowUpRight };
